// extracted by mini-css-extract-plugin
module.exports = {"columnTitle":"editableTitle_columnTitle__1Dpmb","editIntput":"editableTitle_editIntput__3PzBT"};